{
	"pixKeyLabel": "Llave PIX",
	"pixTypeLabel": "Tipo de Llave PIX",
	"pixTypePlaceholder": "Seleccione el tipo de Llave PIX",
	"defaultPlaceholder": "Escriba llave PIX",
	"copyPastePlaceholder": "Pegue su llave PIX",
	"placeholders": {
		"phone": "(41) 99999-9999",
		"cpf": "000.000.000-00",
		"cnpj": "00.000.000/0000-00",
		"email": "ejemplo@email.com",
		"evp": "Llave aleatoria"
	},
	"pixKeyType": {
		"random": "Aleatoria",
		"phone": "Teléfono",
		"copyPaste": "Copiar y Pegar"
	},
	"validation": {
		"invalidPixKey": "Llave PIX inválida"
	}
}
